import { render, staticRenderFns } from "./layout-setting.vue?vue&type=template&id=42b61274&scoped=true"
import script from "./layout-setting.vue?vue&type=script&lang=js"
export * from "./layout-setting.vue?vue&type=script&lang=js"
import style0 from "./layout-setting.vue?vue&type=style&index=0&id=42b61274&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b61274",
  null
  
)

export default component.exports